import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-open-screens',
  templateUrl: './add-open-screens.component.html',
  styleUrls: ['./add-open-screens.component.scss']
})
export class AddOpenScreensComponent implements OnInit {
  
  imagePreview: string | ArrayBuffer = 'assets/images/icons/logo.jpg';
  formData: any = {  
  
  }; // Declare formData property 
    name_ar:any
    name_en: any
    image = this.imagePreview
    body_en : any
    body_ar:any 
    selectedFile: File | null = null;
    public arrCountries:any[] = [];
    public country:any[] = [];
  
    constructor(private router: Router, private apisService: ApisService , 
      private toastr : ToastrService
    ) { }
  
    ngOnInit(): void {
      // this.postCountires();
  
    }
    // postCountires() {
    //   this.apisService.postCountries().subscribe({
    //     next: (data: any) => {
    //       let response: any = data;
    //       if (Array.isArray(response.data)) { 
    //         this.arrCountries = response.data; 
    //       } else {
    //         this.arrCountries = [response.data]; 
    //       }
    //       console.log(this.arrCountries);
    //     },
    //     error: error => {
    //       console.log(error);
    //     }
    //   });
    // }
    
    
    // submitForm(): void {
    //   const formDataToSend = new FormData();
    //   formDataToSend.append('translations[0][locale]', 'ar');
    //   formDataToSend.append('translations[0][name]', this.formData.name_ar);
    //   formDataToSend.append('translations[1][locale]', 'en');
    //   formDataToSend.append('translations[1][name]', this.formData.name_en);
    //   formDataToSend.append('code', this.formData.code);
    //   formDataToSend.append('mobile_code', this.formData.mobile_code);
    //   formDataToSend.append('image', this.formData.image);
    //   formDataToSend.append('mobile_length', this.formData.mobile_length);
    //   formDataToSend.append('mobile_start', this.formData.mobile_start);
  
    //   this.apisService.addCountry(formDataToSend).subscribe({
    //     next: (response: any) => {
    //       console.log('Countries added successfully:', response);
    //       this.formData = {
    //         name_ar: '',
    //         name_en: '',
    //         code: '',
    //         mobile_code: '',
    //         image: '',
    //         mobile_length: '',
    //         mobile_start: ''
    //       };
    //       this.country.push(response.data);
    //       this.router.navigate(['/settings/countries']);
    //     },
    //     error: (error: any) => {
    //       console.log('Error adding countries:', error);
    //     }
    //   });
    // }
  
    cancel(): void {
      this.router.navigate(['/settings/countries']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }

onFileSelected(event: Event): void {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file && file.type.startsWith('image/')) {
    this.selectedFile = file;
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result!;
    };
    reader.readAsDataURL(file);
  } else {
    this.toastr.warning('Please select a valid image file');
  }
}

    
    /*----------  Upload TO api  ----------*/
    addOpenScreen(data:any){
      this.apisService.addOpenScreens(data).subscribe({
        next: (data: any) => {
          this.toastr.success('Open Screens added successfully', 'Success');
                this.router.navigate(['/open-screen']);

        },
        error: (error: any) => {
          console.log(error);
          this.toastr.error('Something went wrong', 'Error');
        }
      })
    }
    

    
    /*----------  Submit function  ----------*/
    onsubmit(){
      const formData = new FormData();
      formData.append('name_ar', this.name_ar);
      formData.append('name_en', this.name_en);
      
      formData.append('body_ar', this.body_ar);
      formData.append('body_en', this.body_en);
        if (this.selectedFile) {
    formData.append('image', this.selectedFile);
  } else {
    this.toastr.warning('Please select an image before submitting.');
    return;
  }

      console.log(formData)
      this.addOpenScreen(formData);
    }
    
}
